<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" v-bind="$attrs">
    <path
      d="M21 10H7V7c0-.55.45-1 1-1s1 .45 1 1h2c0-1.65-1.35-3-3-3S5 5.35 5 7v3H3c-.55 0-1 .45-1 1v2c0 2.4 1.68 4.41 4 4.88V20H4v2h16v-2h-2v-2.12c2.32-.47 4-2.48 4-4.88v-2c0-.55-.45-1-1-1z"
    />
  </svg>
</template>
